const globalRoles = {
    ADMIN: 'Admin',
    CLIENT: 'Client',
    TRANSPORTER: 'Transporter',
    PACKER: 'Packer'
};

export default globalRoles;
